export default {
  init() {
 // /*global localStorage:true*/
 //    if (localStorage.length==0){
      
 //         // $('#reset-local-storage-container').css('display','none');

 //  } else {
 //    // $('#reset-local-storage-container').css('display','inline-block');
  
 var selected_type = localStorage.getItem('[id=apurahojen-hakulomake][name=undefined][id=avustuksen-tyyppi][name=avustuksen-tyyppi]');

  if(selected_type!="") {
    if(selected_type=='Avustushakemus') {
      $('[data-id=ei-valittu-avustuksen-tyyppia-info]').hide();
      $('[data-id=avustushakemus]').show();
      $('[data-id=ei-valittu-avustuksen-tyyppia]').show();
    }
    else if(selected_type=='Apurahahakemus') {
      $('[data-id=ei-valittu-avustuksen-tyyppia-info]').hide();
      $('[data-id=apurahahakemus]').show();
      $('[data-id=ei-valittu-avustuksen-tyyppia]').show();
    }
  }

  $('#reset-local-storage').click(function(){
    var confirmation = confirm("Haluatko varmasti tyhjentää lomakkeen ja poistaa tallennetut tiedot!");
    if (confirmation == true) {
      localStorage.clear();
      location.reload();
    }
  });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/apurahojen-hakemuslomake.js